( function( $, document, window ) {
	'use strict';

	$( function() {
		const swiper = new Swiper('.js-logo-carousel', {
			direction: 'horizontal',
			slidesPerView: 2,
			spaceBetween: 20,
			loop: true,

			breakpoints: {
				640: {
					slidesPerView: 3,
					spaceBetween: 40,
				},
				768: {
					slidesPerView: 4,
					spaceBetween: 60,
				},
				1024: {
					slidesPerView: 6,
					spaceBetween: 80,
				}
			}
		});
	} );
} )( jQuery, document, window );
